import CostaPassSlider from './CostaPassSlider';

export default CostaPassSlider;
